module.exports = __webpack_public_path__ + "static/img/VCR1.4ec9adb1.png";